.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  width: 100%;
  max-width: 460px;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.meter {
  position: relative;
  flex: 1;
  height: 10px;
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
  overflow: hidden;
}

.fill {
  height: 100%;
  transition: width 60ms linear;
}

.fill[data-zone='too quiet'] {
  background: var(--tuna-content-muted);
}

.fill[data-zone='good'] {
  background: var(--tuna-feedback-success);
}

.fill[data-zone='too loud'] {
  background: var(--tuna-feedback-error);
}

/** The voicing gate, so "too quiet" is a place on the bar and not only a word beside it. */
.gate {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--tuna-content-primary);
  opacity: 0.6;
}

.zone {
  min-width: 5.5em;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.zone[data-zone='too loud'] {
  color: var(--tuna-feedback-error);
}

.pitch {
  min-width: 3.5em;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.pitch[data-doubtful='true'] {
  opacity: 0.55;
  font-weight: 400;
}

.device {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
